<template>
  <div name="demo-validate-date-format">
    <input type="text" v-model="dtereq"
         maxlength="10" 
         v-validate="'required|date_format:DD/MM/YYYY'" 
         name="dtereq" 
         data-vv-as="dtereq" 
         placeholder="DD/MM/YYYY" 
         :class="{ 'input-error' : errors.has('dtereq') }" />
    <div v-show="errors.has('dtereq')" class="text-error">{{ errors.first('dtereq') }}</div>
    <hrms-datepicker  v-model="dtework" 
                      v-validate="'required|date_format:DD/MM/YYYY'"
                      data-vv-value-path="inputDate"
                      data-vv-name="dtework"
                      name="dtework"
                      :has-error="errors.has('dtework')" />
    <div class="text-error" v-show="errors.has('dtework')">{{errors.first('dtework')}}</div>
  </div>
</template>

<script>
export default {
  name: 'demo-validate-date-format',
  data () {
    return {
      dtereq: '',
      dtework: ''
    }
  }
}
</script>


// WEBPACK FOOTER //
// demoValidateDateFormat.vue?6158910f